/**
 * Confirm or fail a payment awaiting confirmation.
 *
 * A transfer is confirmed on the reference its confirmer reads off the bank
 * alert now — one reference pays once — so the row asks for it before
 * Confirm is offered. Card and terminal payments confirm on the slip.
 */

import { useState, type ReactNode } from 'react';
import { Button } from '../../components/ui';
import { needsTransferReference, transferReferenceReady } from '../../lib/till';

export type PendingDecisionBody = { id: string; outcome: 'confirmed' | 'failed'; providerReference?: string };

export function PendingDecision({
  payment,
  busy,
  onDecide,
}: {
  payment: { id: string; method: string };
  busy: boolean;
  onDecide: (body: PendingDecisionBody) => void;
}): ReactNode {
  const [reference, setReference] = useState('');
  const asksReference = needsTransferReference(payment.method);
  return (
    <span className="flex flex-wrap items-center gap-1.5">
      {asksReference && (
        <input
          aria-label="Transfer reference"
          placeholder="Reference on the bank alert"
          className="input-base h-8 text-sm"
          value={reference}
          onChange={(e) => setReference(e.target.value)}
        />
      )}
      <Button
        size="sm"
        loading={busy}
        disabled={asksReference && !transferReferenceReady(reference)}
        onClick={() =>
          onDecide({ id: payment.id, outcome: 'confirmed', ...(asksReference ? { providerReference: reference.trim() } : {}) })
        }
      >
        Confirm
      </Button>
      <Button size="sm" variant="ghost" onClick={() => onDecide({ id: payment.id, outcome: 'failed' })}>
        Failed
      </Button>
    </span>
  );
}
